module.exports = __webpack_public_path__ + "static/media/blinds.d20bf1e3.svg";